import React from 'react';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@mui/styles';
import crossIcon from '../assets/reject.png'

const useStyles = makeStyles({
    button: {
        alignItems: 'center',
        color: '#FFFFFF',
        borderRadius: '8px',
        padding: '0.5rem 1rem',
        fontSize: '12.5px',
        width: '7rem',
        height: '2rem',
        backgroundColor: '#E95E5E !important',
        '&:hover': {
            backgroundColor: '#E95E5EBF',
        },
    },
    icon: {
        marginRight: '8px',
        width: '20px',
        height: '20px',
    },
})

const RedButton = ({ id, backgroundColor, hasIcon, ...otherProps }) => {
    const classes = useStyles();

    return (
        <Button variant="contained" className={classes.button} {...otherProps}>
            {hasIcon && <img src={crossIcon} alt="OK Icon" className={classes.icon} />}
            <FormattedMessage id={id} />
        </Button>
    )
}

export default RedButton;
